// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3XL19","modal_content":"styles_modal_content__1e640","zoom":"styles_zoom__LewhZ","close_icon":"styles_close_icon__24nvQ"};